import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { logout_user, SEND_ALERT } from '@plootus/common';

const useSessionTimeout = (onTimeout, tokenKey = 'jwt_token', timeoutMs = 30 * 60 * 1000) => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const handleLogout = async () => {
    if (!localStorage.getItem(tokenKey)) return;

    dispatch({
      type: SEND_ALERT,
      payload: {
        title: 'Session Timeout',
        textContent: 'You have been logged out due to inactivity.',
      },
    });
    
    localStorage.removeItem(tokenKey);
    dispatch(logout_user());
    if (onTimeout) onTimeout();
  };

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (!localStorage.getItem(tokenKey)) return;
    
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, timeoutMs);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    
    const handleActivity = () => resetTimeout();

    events.forEach(event => {
      window.addEventListener(event, handleActivity);
    });

    resetTimeout(); // Initialize timeout

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      events.forEach(event => {
        window.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  return resetTimeout;
};

export default useSessionTimeout;
